var r={exports:{}};export{r as c};
//# sourceMappingURL=index2.js.map
